
import { AuthService } from '@/services/auth/AuthService';
export default {
  install(Vue) {
    Vue.prototype.$auth = new AuthService(Vue.prototype.$axios);
  }
}